(() => {
  if (window.__instabeamConversionCartLoaded) return;
  window.__instabeamConversionCartLoaded = true;

  const STORAGE_KEY = 'instabeam_reception_result_v2';
  const PLACE_TTL = 30 * 86400000;
  const RESULT_TTL = 30 * 86400000;
  const MAJOR_ORDER = ['ABC','CBS','FOX','NBC','PBS','The CW','ION','Univision','Telemundo','UniMás'];
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const clean = value => String(value == null ? '' : value).replace(/\s+/g, ' ').trim();

  function normalizePath(value) {
    if (!value) return '';
    try { return new URL(value, window.location.origin).pathname.replace(/\/$/, ''); }
    catch (_) { return String(value).split('?')[0].replace(/\/$/, ''); }
  }

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !/^\d{5}$/.test(String(parsed.zip || ''))) return null;
      if (parsed.updatedAt && Date.now() - Number(parsed.updatedAt) > RESULT_TTL) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (_) { return null; }
  }

  function writeStored(update) {
    if (!update) return null;
    const current = readStored() || {};
    const next = { ...current, ...update, updatedAt: Date.now() };
    next.zip = String(next.zip || '').replace(/\D/g, '').slice(0, 5);
    if (!/^\d{5}$/.test(next.zip)) return null;

    // Preserve the useful recommendation fields when a later checker refresh only updates reception.
    if (!update.recommendedProductUrl && current.recommendedProductUrl) next.recommendedProductUrl = current.recommendedProductUrl;
    if (!update.recommendedProductId && current.recommendedProductId) next.recommendedProductId = current.recommendedProductId;
    if (!update.recommendedProductTitle && current.recommendedProductTitle) next.recommendedProductTitle = current.recommendedProductTitle;

    try {
      const beforeComparable = { ...current };
      const nextComparable = { ...next };
      delete beforeComparable.updatedAt;
      delete nextComparable.updatedAt;

      if (JSON.stringify(beforeComparable) !== JSON.stringify(nextComparable)) {
        next.updatedAt = Date.now();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        window.dispatchEvent(new CustomEvent('instabeam:reception-updated', { detail: next }));
        return next;
      }
      return current;
    } catch (_) {}
    return next;
  }

  window.InstaBeamReception = window.InstaBeamReception || {};
  window.InstaBeamReception.get = readStored;
  window.InstaBeamReception.save = writeStored;
  window.InstaBeamReception.clear = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    window.dispatchEvent(new CustomEvent('instabeam:reception-updated', { detail: null }));
  };

  function canonicalNetwork(name) {
    const v = clean(name);
    if (!v) return '';
    const low = v.toLowerCase();
    const map = {
      'abc':'ABC', 'american broadcasting company':'ABC',
      'cbs':'CBS',
      'fox':'FOX', 'fox broadcasting company':'FOX',
      'nbc':'NBC',
      'pbs':'PBS',
      'the cw':'The CW', 'cw':'The CW',
      'ion':'ION', 'ion television':'ION',
      'univision':'Univision',
      'telemundo':'Telemundo',
      'unimás':'UniMás', 'unimas':'UniMás'
    };
    return map[low] || v;
  }

  function scrapeNetworks(checker) {
    const found = new Map();
    $$('.ib-station', checker).forEach(card => {
      const name = canonicalNetwork($('.ib-network', card)?.textContent || '');
      if (!name || found.has(name)) return;
      const img = $('.ib-logo', card);
      found.set(name, { name, logo: img?.currentSrc || img?.src || '' });
    });

    return Array.from(found.values())
      .sort((a, b) => {
        const ai = MAJOR_ORDER.indexOf(a.name), bi = MAJOR_ORDER.indexOf(b.name);
        const av = ai === -1 ? 999 : ai, bv = bi === -1 ? 999 : bi;
        return av - bv;
      })
      .slice(0, 10);
  }

  function dmaFromCache(zip) {
    try {
      const raw = localStorage.getItem('ib_zip_dma_exact_v2_' + zip);
      if (!raw) return '';
      const parsed = JSON.parse(raw);
      return clean(parsed?.data?.name || parsed?.data?.market || parsed?.name || '');
    } catch (_) { return ''; }
  }

  function marketFromMeta(text) {
    const meta = clean(text).replace(/\s*\.\s*$/, '');
    if (!meta) return '';
    let match = meta.match(/\bin\s+(.+)$/i);
    if (match) return clean(match[1]);
    match = meta.match(/^Local\s+(.+?)\s+stations\b/i);
    if (match) return clean(match[1]);
    return '';
  }

  function channelCountFromChecker(checker) {
    const title = clean($('.ib-result-title', checker)?.textContent || '');
    let match = title.match(/(\d+)\+?\s+Local TV Channel/i);
    if (match) return Number(match[1]);
    const total = clean($('.ib-total-stations', checker)?.textContent || '');
    match = total.match(/(\d+)/);
    return match ? Number(match[1]) : null;
  }

  async function placeForZip(zip) {
    const key = 'instabeam_zip_place_v1_' + zip;
    try {
      const raw = localStorage.getItem(key);
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached?.data && Date.now() - Number(cached.ts || 0) < PLACE_TTL) return cached.data;
      }
    } catch (_) {}

    try {
      const response = await fetch('https://api.zippopotam.us/us/' + encodeURIComponent(zip), { credentials: 'omit' });
      if (!response.ok) return null;
      const data = await response.json();
      const place = data?.places?.[0];
      if (!place) return null;
      const result = {
        city: clean(place['place name'] || ''),
        state: clean(place['state abbreviation'] || place.state || '')
      };
      try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: result })); } catch (_) {}
      return result;
    } catch (_) { return null; }
  }

  async function captureChecker(checker, detail = {}) {
    if (!checker) return;
    const input = $('.ib-zip', checker);
    const zip = clean(detail.zip || input?.value || '').replace(/\D/g, '').slice(0, 5);
    if (!/^\d{5}$/.test(zip)) return;

    const results = $('.ib-results', checker);
    if (results && results.hidden && !detail.channelCount) return;

    const countDetail = Number(detail.channelCount);
    const channelCount = Number.isFinite(countDetail) ? countDetail : channelCountFromChecker(checker);
    if (channelCount === null || !Number.isFinite(Number(channelCount))) return;

    const meta = $('.ib-result-meta', checker)?.textContent || '';
    const market = clean(detail.market || dmaFromCache(zip) || marketFromMeta(meta));
    const networks = scrapeNetworks(checker);

    const base = {
      zip,
      market,
      channelCount: Number(channelCount),
      networks,
      distanceProfile: clean(detail.distanceProfile || ''),
      directionProfile: clean(detail.directionProfile || ''),
      referenceDistance: Number.isFinite(Number(detail.referenceDistance)) ? Number(detail.referenceDistance) : null,
      source: 'InstaBeam ZIP checker'
    };

    // If this ZIP was checked directly on a product page, retain that context without claiming recommendation.
    if (/^\/products\//.test(window.location.pathname)) base.checkedProductUrl = window.location.pathname;

    writeStored(base);
    const place = await placeForZip(zip);
    if (place) writeStored({ zip, city: place.city, state: place.state });
  }

  function recommendationSnapshot() {
    const section = $('[data-ibc-section="recommendation"]');
    if (!section || section.hidden) return;
    const link = $('[data-ibc-rec-link][href]', section);
    const title = clean($('[data-ibc-rec-title]', section)?.textContent || '');
    const path = normalizePath(link?.getAttribute('href') || '');
    if (!path || path === '#') return;

    let productId = '';
    const source = $$('.ibc-product').find(card => normalizePath(card.getAttribute('data-product-url') || '') === path);
    if (source) productId = clean(source.getAttribute('data-ibc-product') || '');

    const current = readStored();
    if (!current) return;
    writeStored({
      zip: current.zip,
      recommendedProductUrl: path,
      recommendedProductId: productId,
      recommendedProductTitle: title
    });
  }

  function cartProducts(card) {
    try { return JSON.parse($('[data-ib-cart-products]', card.closest('.ib-cart-top'))?.textContent || '[]'); }
    catch (_) { return []; }
  }

  function recommendationMatchesCart(data, card) {
    if (!data) return false;
    const wantedPath = normalizePath(data.recommendedProductUrl || '');
    const wantedId = String(data.recommendedProductId || '');
    if (!wantedPath && !wantedId) return false;
    return cartProducts(card).some(product => {
      return (wantedId && String(product.id || '') === wantedId) ||
             (wantedPath && normalizePath(product.url || '') === wantedPath);
    });
  }

  function renderReception() {
    const data = readStored();
    $$('[data-ib-reception-card]').forEach(card => {
      if (!data) {
        card.hidden = true;
        delete card.dataset.ibReceptionFingerprint;
        return;
      }

      const exactMatch = recommendationMatchesCart(data, card);
      const fingerprint = JSON.stringify([
        data.zip, data.city, data.state, data.market, data.channelCount, data.networks,
        exactMatch, card.dataset.showMarket, card.dataset.showNetworks, card.dataset.showFit
      ]);
      if (card.dataset.ibReceptionFingerprint === fingerprint) {
        card.hidden = false;
        return;
      }
      card.dataset.ibReceptionFingerprint = fingerprint;

      const location = $('[data-ib-reception-location]', card);
      const market = $('[data-ib-reception-market]', card);
      const result = $('[data-ib-reception-result]', card);
      const networks = $('[data-ib-reception-networks]', card);
      const fit = $('[data-ib-reception-fit]', card);

      const cityState = [clean(data.city), clean(data.state)].filter(Boolean).join(', ');
      location.textContent = cityState ? `${cityState} · ${data.zip}` : `ZIP ${data.zip}`;

      if (card.dataset.showMarket === 'true' && clean(data.market)) {
        market.textContent = `${clean(data.market)} TV Market`;
        market.hidden = false;
      } else {
        market.hidden = true;
      }

      const count = Number(data.channelCount);
      result.textContent = Number.isFinite(count)
        ? `${count} local channel${count === 1 ? '' : 's'} found`
        : 'Local reception profile saved';

      networks.innerHTML = '';
      const list = Array.isArray(data.networks) ? data.networks : [];
      if (card.dataset.showNetworks === 'true' && list.length) {
        const visible = list.slice(0, 5);
        visible.forEach(network => {
          const name = clean(typeof network === 'string' ? network : network.name);
          if (!name) return;
          const pill = document.createElement('span');
          pill.className = 'ib-network-pill';
          const logo = typeof network === 'object' ? clean(network.logo) : '';
          if (logo) {
            const img = document.createElement('img');
            img.src = logo;
            img.alt = name;
            img.loading = 'lazy';
            img.addEventListener('error', () => { pill.textContent = name; }, { once: true });
            pill.appendChild(img);
          } else {
            pill.textContent = name;
          }
          networks.appendChild(pill);
        });
        const remainder = list.length - visible.length;
        if (remainder > 0) {
          const more = document.createElement('span');
          more.className = 'ib-network-pill ib-network-pill--more';
          more.textContent = `+${remainder} more`;
          networks.appendChild(more);
        }
        networks.hidden = false;
      } else {
        networks.hidden = true;
      }

      if (fit) fit.hidden = !(card.dataset.showFit === 'true' && exactMatch);
      card.hidden = false;
    });
  }

  async function addUpsell(button) {
    const id = button.dataset.variantId;
    const drawer = $('cart-drawer');
    if (!id || !drawer) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING…';

    try {
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
      const formData = new FormData();
      formData.append('id', id);
      formData.append('quantity', '1');
      if (typeof drawer.getSectionsToRender === 'function') {
        formData.append('sections', drawer.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add item');

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        try {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'instabeam-cart-upsell',
            productVariantId: id,
            cartData: data
          });
        } catch (_) {}
      }

      if (typeof drawer.renderContents === 'function' && data.sections) drawer.renderContents(data);
      else window.location.reload();
    } catch (error) {
      console.error('[InstaBeam cart] Upsell add failed:', error);
      button.disabled = false;
      button.textContent = 'TRY AGAIN';
      setTimeout(() => { if (button.isConnected) button.textContent = original; }, 1400);
    }
  }

  function bindUpsells() {
    $$('[data-ib-upsell-add]').forEach(button => {
      if (button.dataset.ibBound === '1') return;
      button.dataset.ibBound = '1';
      button.addEventListener('click', () => addUpsell(button));
    });
  }

  function scanAll() {
    $$('[data-ib-checker]').forEach(checker => {
      const results = $('.ib-results', checker);
      const zip = clean($('.ib-zip', checker)?.value || '').replace(/\D/g, '').slice(0, 5);
      if (!/^\d{5}$/.test(zip) || (results && results.hidden)) return;
      const resultTitle = clean($('.ib-result-title', checker)?.textContent || '');
      if (/so far|finding|scanning|checking/i.test(resultTitle)) return;
      const count = channelCountFromChecker(checker);
      if (count !== null) captureChecker(checker).catch(() => {});
    });
    recommendationSnapshot();
    renderReception();
    bindUpsells();
  }

  document.addEventListener('ib:zip-complete', event => {
    const checker = event.target?.closest?.('[data-ib-checker]') || event.target;
    captureChecker(checker, event.detail || {}).catch(() => {});
  });

  function clearForFreshLookup() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    renderReception();
  }

  document.addEventListener('ib:zip-start', () => {
    // Never show a completed result while a fresh ZIP scan is running.
    clearForFreshLookup();
  });

  document.addEventListener('click', event => {
    const button = event.target?.closest?.('[data-ib-checker] .ib-check');
    if (button) clearForFreshLookup();

    // Capture the exact catalog recommendation before navigation, even on a very fast click.
    if (event.target?.closest?.('[data-ibc-rec-link]')) recommendationSnapshot();
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    const input = event.target?.closest?.('[data-ib-checker] .ib-zip');
    if (input) clearForFreshLookup();
  }, true);

  window.addEventListener('instabeam:reception-updated', renderReception);
  window.addEventListener('storage', event => { if (event.key === STORAGE_KEY) renderReception(); });
  document.addEventListener('shopify:section:load', scanAll);

  let timer = 0;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(scanAll, 180);
  });

  function start() {
    scanAll();
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden','href'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
